import { Badge } from "@/components/ui/badge";
import { STATUS_STYLES, STATUS_LABEL } from "@/lib/roMeta";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, className }) {
  return (
    <Badge
      variant="outline"
      data-testid={`status-badge-${status}`}
      className={cn("font-mono text-[11px] uppercase tracking-wider", STATUS_STYLES[status] || STATUS_STYLES.pending_audit, className)}
    >
      {STATUS_LABEL[status] || status}
    </Badge>
  );
}
